import { Field } from 'components/Form/Field/Field';
import { Textarea } from 'components/Textarea/Textarea';

type Props = {
  name: string;
  label?: string;
  description?: string;
  qaId?: string;
  disabled?: boolean;
};

export function RequestedTextUserField({
  name,
  label,
  description,
  qaId,
  disabled,
}: Props) {
  const subName = `${name}.text`;
  return (
    <Field
      customErrorMatch={(errors) => errors[name] ?? errors[subName]}
      name={name}
      label={label}
      description={description}
      renderInput={({ value, qaId: fieldQaId, updateValue }) => (
        <Textarea
          disabled={disabled}
          name={name}
          data-qa-id={`${qaId ?? fieldQaId}-hidden-input`}
          onChange={(e) => {
            const v = e.target.value;

            updateValue(
              v
                ? {
                    type: 'TEXT',
                    text: v,
                  }
                : null,
            );
          }}
          value={value ? value.text : ''}
        />
      )}
    />
  );
}
